<template>
  <div class="box_home">
    <div class="top">
      <div class="carInfo" v-for="(item,index) in carList" :key="index">
        <div class="car_left">
          <div style="margin-bottom: 20px">
            <el-button
              type="primary"
              style="margin-right: 10px; margin-bottom: 20px"
              >{{item.carNumber}}</el-button
            >
            <span>{{item.status}}</span>
          </div>
          <div style="margin-bottom: 20px">车位:{{item.stallStatus}}</div>
          <div style="margin-bottom: 20px">车牌色：{{item.label}}</div>
        </div>
        <div class="car_center">
          <div style="width: 48%; height: 90%">
            <img
              style="width: 100%; height: 100%"
              :src="http+item.enterPhoto"
              alt=""
            />
            <img src="../../assets/image/in.png" alt="" />
            <span>进场</span>
          </div>
          <div style="width: 48%; height: 90%">
            <img
              style="width: 100%; height: 100%"
              :src="http+item.outPhoto"
              alt=""
            />
            <img src="../../assets/image/out.png" alt="" />
            <span>出场</span>
          </div>
        </div>
        <div class="car_right">
          <div style="margin-bottom: 20px">出场时间：{{item.enterDate}}</div>
          <div style="margin-bottom: 20px">入场时间：{{item.outDate}}</div>
          <div style="margin-bottom: 20px">停车时长：{{item.parkingTime}}小时</div>
          <div style="margin-bottom: 20px">计费方式：5/小时</div>
          <div style="margin-bottom: 20px">应收费用：</div>
          <div style="margin-bottom: 20px">实收费用：</div>
        </div>
      </div>
    </div>
    <div class="el-end">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      carList:[],
      http:base.httpCtx
    }
  },
  mounted() {
    this.projectId = util.session.get('groupId')
    if (this.projectId == '') {
      this.$store.commit('setGroupId')
      this.projectId = this.$store.state.groupId
    }
    console.log(base.httpCtx)
    this.getData()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    getData() {
      var that = this
      myHttp
        .selectCarInoutLog({
          time:'',
          projectId: this.projectId,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.logs.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index =
                  that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                list[i].photo =
                  list[i].carportPhoto && list[i].carportPhoto != ''
                    ? base.httpCtx + list[i].carportPhoto
                    : ''
                list[i].srcList =
                  list[i].photo && list[i].photo != '' ? [list[i].photo] : []
              }
              that.carList = list
              that.totalItems = resp.data.data.logs.total
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {}
        )
    },
  },
}
</script>
<style scoped>
.box_home {
  background: #ffffff;
  width: 100%;
  height: 98%;
  margin: 1%;
}
.carInfo {
  height: 350px;
  border-bottom: 5px solid #f5f5f5;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.car_left {
  width: 20%;
  border-right: 5px solid #f5f5f5;
  padding: 20px;
  text-align: left;
  /* height: 50%;
   display: flex;
   flex-direction: column;
   justify-content: space-between; */
}
.car_center {
  width: 60%;
  border-right: 5px solid #f5f5f5;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.car_right {
  padding: 20px;
  text-align: left;
  width: 20%;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.top {
  height: calc(100% - 67px);
  width: 100%;
  overflow: auto
}
</style>